import { ref } from 'vue';

const STORAGE_KEY = 'signup-sponsorship-code';

const readStoredCode = () => {
  if (typeof window === 'undefined') return null;

  return window.sessionStorage.getItem(STORAGE_KEY);
};

// Module-level singleton — survives component unmount
const capturedCode = ref<string | null>(readStoredCode());

export function useSponsorshipCode() {
  const setCode = (code: string) => {
    capturedCode.value = code;
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(STORAGE_KEY, code);
    }
  };

  const clearCode = () => {
    capturedCode.value = null;
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  };

  return { capturedCode, setCode, clearCode };
}
